const DEFAULT_RETRYABLE_STATUS_CODES = [408, 425, 429, 500, 502, 503, 504];
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
function isRetryableStatus(status, retryableStatusCodes) {
    return retryableStatusCodes.includes(status);
}
/**
 * Fetch wrapper with retry/backoff for transient local-backend failures.
 */
export async function fetchWithRetry(input, init, options) {
    const maxAttempts = options?.maxAttempts ?? 3;
    const initialDelayMs = options?.initialDelayMs ?? 250;
    const maxDelayMs = options?.maxDelayMs ?? 2000;
    const retryableStatusCodes = options?.retryableStatusCodes ?? DEFAULT_RETRYABLE_STATUS_CODES;
    let attempt = 0;
    let delayMs = initialDelayMs;
    let lastError = null;
    while (attempt < maxAttempts) {
        attempt += 1;
        try {
            const response = await fetch(input, init);
            if (response.ok || !isRetryableStatus(response.status, retryableStatusCodes) || attempt === maxAttempts) {
                return response;
            }
            console.warn(`[fetchWithRetry] Attempt ${attempt}/${maxAttempts} failed with status ${response.status}. Retrying in ${delayMs}ms.`);
        }
        catch (error) {
            lastError = error;
            if (attempt === maxAttempts) {
                throw error;
            }
            console.warn(`[fetchWithRetry] Attempt ${attempt}/${maxAttempts} threw network error. Retrying in ${delayMs}ms.`, error);
        }
        await sleep(delayMs);
        delayMs = Math.min(delayMs * 2, maxDelayMs);
    }
    throw lastError instanceof Error
        ? lastError
        : new Error("fetchWithRetry failed after all retry attempts.");
}
